export const sortLeads = (leads) =>
  [...leads].sort(
    (a, b) => (b.referrals || 0) - (a.referrals || 0) || new Date(a.created_at) - new Date(b.created_at)
  );

export const blastPending = (leads) => leads.filter((l) => !l.blast_sent_at && !l.blast_failed).length;

export const countdownPending = (leads) => leads.filter((l) => !l.countdown_sent_at && !l.blast_failed).length;

export const perkRows = (leads) =>
  leads.flatMap((l) =>
    (l.perks || []).map((p) => ({
      leadId: l.id,
      email: l.email,
      referrals: l.referrals || 0,
      ...p,
    }))
  );
